
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './proyectosproductivosigdy.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pproyectosproductivosigdy = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6931bb7e8e5aed52dc8a9ee2" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iumht8"
          href="/"
        >
          
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="iijdu7"
          href="/sobrenosotros"
        >
          
    <div id="inoik6" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijau3l"
          href="/proyectos"
        >
          
    <div id="i1h6oa" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i3lnta"
          href="/campanas"
        >
          
    <div id="iunupg" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="imshx9"
          href="/impacto"
        >
          
    <div id="itxxvc" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ifr1lk"
          href="convenios"
        >
          
    <div id="i5dgxe" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ip93t8"
          href="/transparencia"
        >
          
    <div id="ienp1j" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-primario "
          id="iiit99"
          href="/contacto"
        >
          
    <div id="i1fieg" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campanas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingwtg">
        <>Proyectos</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div className="" id="i83s7t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i2uc23">
        <>Fundación Petrus desarrolla cadenas productivas que combinan productividad, sostenibilidad y valor social para las familias campesinas.</>
      </span>
      
      </div>
      
      </div>
      
      <div id="iencce" className="">
      
      <div className="" id="i7p7tx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ie7jd4">
        <>Equipo directivo</>
      </span>
      
      </div>
      
      </div>
      
      <div id="iuo301" className="">
      
      <div id="ixrbfk" className="">
      
      <div id="ivy1ig" className="tarjeta-persona ">
      
      <div id="i0atys" className="">
      
      <img
        className=""
        id="i3okln"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirnp5ac.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iggr93" className="">
      
      <div className="titulo-tarjeta-persona " id="iu4a2q">
        <>Vivero Regional de Cacao Fino de Aroma</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i8097h">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieyyc8">
        <>Proyecto insignia de VICAMPAZ, ubicado en la Finca La Comuna, que impulsa la siembra y resiembra de cacao FINO DE AROMA para la región.
</>
      </span>
      
      <br className="" id="" />
      
    <div id="" className="">
    
    <div id="is7b3t" className="">
    <>9.720 árboles de cacao sembrados en cuatro variedades Fino Aroma.</>
    </div>
    
    <div id="i0dvlg" className="">
    <>Meta: 20.000 plántulas en crecimiento y producción.</>
    </div>
    
    <div id="i94rml" className="">
    <>Beneficio para 19 asociaciones cacaoteras del Eje Cafetero.</>
    </div>
    
    <div id="imyn3v" className="">
    <>Acompañamiento de FEDECACAO, ICA Risaralda y ASNACAVA.</>
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="iy4zhy" className="tarjeta-persona ">
      
      <div id="ii3vst" className="">
      
      <img
        className=""
        id="ivyx5l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirog8v0.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ik1gkg" className="">
      
      <div className="titulo-tarjeta-persona " id="i2hh9l">
        <>Fortalecimiento de la Cadena Plátano</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="ioy086">
        
      <span className="" id="">
        
      </span>
      <>Programa orientado a mejorar la productividad, sanidad y manejo ambiental del cultivo de plátano en la Finca La Comuna.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Implementación de programas de competitividad y renovación de cultivos.</>
      <br className="" id="" />
      <>Manejo fitosanitario y orgánico del cultivo.</>
      <br className="" id="" />
      <>Articulación a cadenas productivas locales y regionales.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="inw11u" className="tarjeta-persona ">
      
      <div id="i1xkib" className="">
      
      <img
        className=""
        id="ialy8v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiroi4e2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ixoe62" className="">
      
      <div className="titulo-tarjeta-persona " id="ikfysk">
        <>Siembra de Sacha Inchi</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i6mh9j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ihvjd1">
        <>Iniciativa de diversificación productiva mediante la introducción de la cadena sacha inchi como cultivo de alto valor nutricional y comercial.
</>
      </span>
      
      <br className="" id="" />
      
    <div id="" className="">
    
    <div id="icgszr" className="">
    <>Siembra inicial de 3 hectáreas de sacha inchi.</>
    </div>
    
    <div id="iiur3x" className="">
    <>Desarrollo bajo alianza estratégica con la ONG AGROMERIS de Dosquebradas.</>
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="i2mnpm" className="tarjeta-persona ">
      
      <div id="if153d" className="">
      
      <img
        className=""
        id="ixkoye"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirojeiu.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iutdca" className="">
      
      <div className="titulo-tarjeta-persona " id="i63vzj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="im0o02">
        <>Huerta Comunitaria</>
      </span>
      
      </div>
      
      <div className="cargo-tarjeta-persona " id="ivn5x7">
        <>Proyecto de seguridad alimentaria que produce hortalizas y alimentos frescos para las familias que habitan el predio La Comuna.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Implementada con apoyo de la Gobernación de Risaralda y la UTP.</>
      <br className="" id="" />
      <>Fomenta el autoconsumo, la alimentación saludable y la educación en huertas.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="icvuhe">
        <>Fundación Petrus</>
      </span>
      
      </div>
      
      <img
        className=""
        id="imlyex"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="invc11" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Páginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="ifh4ms">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="il1rnw">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pproyectosproductivosigdy);
  